module.exports = __webpack_public_path__ + "img/sixpackcarrier105.0a76300d.jpg";